export enum SpacingSize {
    XSmall = 'xsmall',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

export enum PaddingSize {
    XSmall = 'xsmall',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

export enum DividerVariant {
    Default = 'default',
    Muted = 'muted',
    Emphasis = 'emphasis',
}
